# import MemberFragment from "../fragments/member.graphql"

mutation createTeamMember($input: MemberInput!) {
  createTeamMember(input: $input) {
    ...MemberFragment
  }
}
